export type AutoReloadProps = {
  enabled: boolean
  retries: number
  showReloadButton?: boolean
}

export function getReloadAttempt() {
  const attempt = parseInt(localStorage.getItem("reload/count") || "0")
  const lastAttemptTs = localStorage.getItem("reload/timestamp")
  const lastAttempt = lastAttemptTs ? new Date(parseInt(lastAttemptTs)) : null
  if (
    lastAttempt !== null &&
    // reset attempts after 15 seconds
    new Date().getTime() - lastAttempt.getTime() < 1 * 15_000
  ) {
    return attempt
  }
  return 0
}

export function setReloadAttempt(attempts: number) {
  localStorage.setItem("reload/count", attempts.toString())
  localStorage.setItem("reload/timestamp", Date.now().toString())
}
